import {Injectable} from '@angular/core';

declare let iNet: any;

const FILES_FORMAT = [
    'unknown', 'text', 'archive', 'audio', 'video',
    'png', 'jpg', 'gif', 'tiff', 'svg', 'ai', 'psd', 'dwg',
    'avi', 'fla', 'mp2', 'mp3', 'mp4', 'aac', 'flac', 'wma', 'wav', 'mxf',
    'iso', 'mdf', 'nrg',
    'zip', '7z', 'arj', 'rar',
    'pdf', 'doc', 'rtf', 'txt', 'xls', 'ppt',
    'css', 'csv', 'html', 'json', 'js', 'xml',
    'dbf', 'exe'
];

const FILES_EDIT_FORMAT = [
    'doc', 'docx', 'odt', 'ods', 'xls', 'xlsx',
    'ppt', 'pps', 'pptm', 'pptx','pot', 'potx',
    'dot', 'dotx', 'docm','dotx', 'csv' , 'sxw']
;

const FILES_VIEW_FORMAT = ['pdf', 'png', 'jpg' ,'jpeg' , 'gif'];

const UNKNOWN = 'unknown';

@Injectable()
export class FileFormatService {

    constructor() {}

    getImagePath(): string {
        let path =  iNet.commonImageFolder;
        const lastIndex = path.lastIndexOf('/');
        if (lastIndex === path.length - 1) {
            return path.substring(0, lastIndex);
        }
        return path;
    }

    getFileFormatPath(): string {
        return `${this.getImagePath()}/format`;
    }

    getUrlByExt(ext: string) {
        const path = this.getFileFormatPath();
        if (FILES_FORMAT.indexOf(ext) > -1) {
            return `${path}/${ext.toLowerCase()}.svg`
        }
        return `${path}/${UNKNOWN}.svg`
    }

    getUrlByName(name: string) {
        return this.getUrlByExt(this.getExtByName(name));
    }

    getExtByName(name: string) {
      return name.split('.').pop()?.toLowerCase() || UNKNOWN;
    }

    getEditFormats(): string[] {
        return FILES_EDIT_FORMAT;
    }

    getViewFormats(): string[] {
        return FILES_VIEW_FORMAT;
    }

}
